import axios from 'axios'


const axiosInstance=axios.create({
    // baseURL:'http://localhost:5521/user'
    baseURL:"https://api.ocfitseed.com/user"
    // baseURL:'http://15.206.68.199:5624/user'
});

axiosInstance.interceptors.request.use((config)=>{
    return config;

},(err)=>{
    console.log(err);
    return Promise.reject(err)
});

axiosInstance.interceptors.response.use((res)=>{
    if(typeof res.data==="string"){
        return {data:res.data,headers:res.headers};
    }else{
        return {...res.data,headers:res.headers};
    }

},(err)=>{
    let res={};
    if(typeof err?.response?.data!=="undefined"){
        res=err?.response?.data;
        if(!res?.message){
            res.message=err?.message;
        }

        if(res.errors && Array.isArray(res.errors)){
            res.message=res.errors[0].msg;
        }

    }else{
        res.message=err.message
    }

    return Promise.reject(res);

});


export default axiosInstance;
